import { DEFAULT_LOCALE_KEY, LOCALE_KEY, LOCALE_STORE_KEY } from '@/constant/cache-key'
import type { LocalesMap } from '@/store/modules/locale/types'
import { loadStorage } from '@/utils/cache'

const useLocalesStore = defineStore('locale', () => {
  const locales = ref<LocalesMap>({
    'zh-CN': {},
    'en-US': {},
  })
  const locale = computed(() => loadStorage(LOCALE_KEY, DEFAULT_LOCALE_KEY))

  const message = computed(() => locales.value)

  function setLocals(locale: LocalesMap) {
    locales.value = locale
  }

  return {
    locale,
    locales,
    message,
    setLocals,
  }
}, {
  // https://prazdevs.github.io/pinia-plugin-persistedstate/zh/guide/config.html
  persist: {
    key: LOCALE_STORE_KEY,
  },
})

// export default () => {
//   const store = useLocalesStore()

//   const { currentLocales } = storeToRefs(store)
//   const { setLocals } = store

//   return {
//     currentLocales,
//     setLocals,
//   }
// }

export default useLocalesStore
